module.exports = __webpack_public_path__ + "img/people-35.56eba603.png";